import { render, staticRenderFns } from "./FrontpageVideo.vue?vue&type=template&id=125d0074&"
import script from "./FrontpageVideo.vue?vue&type=script&lang=js&"
export * from "./FrontpageVideo.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageVideo.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports